import { Body } from '@/components/organisms/Admin/Leveling/Body'

export function LevelingPage() {
	return (
		<div className='flex flex-col'>
			<Body />
		</div>
	)
}
